module.exports = __webpack_public_path__ + "img/thumb_04.09fb927c.jpg";